<template>
    <section>
        <multiselect class="chat-queues-multiselect" v-model="computedSelected" :options="options" :multiple="true"
            :close-on-select="false" :clear-on-select="false" :hide-selected="false" :preserve-search="false"
            placeholder="Selecione as filas" label="name" track-by="id" :preselect-first="false" :searchable="false"
            :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
            :selected-label="'Selecionado'">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length">
                    {{ values.length }} fila(s) selecionada(s)
                </span>
            </template>
        </multiselect>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        reset: Boolean,
        useIds: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            options: []
        };
    },
    computed: {
        computedSelected: {
            get() {
                if (this.useIds) {
                    return this.value.map(id => this.options.find(option => option.id === id));
                }
                return this.value;
            },
            set(selected) {
                if (this.useIds) {
                    const ids = selected.map(obj => obj.id);
                    this.$emit('input', ids);
                } else {
                    this.$emit('input', selected);
                }
            }
        }
    },
    async mounted() {
        await this.getChatQueues();
    },
    methods: {
        async getChatQueues() {
            await axios.get('/listQueueChat')
                .then(({ data }) => {
                    this.options = data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
    }
};
</script>

<style lang="scss" scoped>
.chat-queues-multiselect {
    font-size: 14px;

    ::v-deep .multiselect__tags {
        padding: 5px 40px 0 8px;
        max-height: 37px;
        min-height: unset;
        border-radius: unset;
        border: 1px solid lightgray;
    }

    ::v-deep .multiselect__single {
        font-size: small;
    }
}
</style>